import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastMessage {
  message: string;
  type: ToastType;
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject = new Subject<ToastMessage>();
  toast$ = this.toastSubject.asObservable();

  success(message: string, duration = 3000): void {
    this.toastSubject.next({ message, type: 'success', duration });
  }

  error(message: string, duration = 4000): void {
    this.toastSubject.next({ message, type: 'error', duration });
  }

  info(message: string, duration = 3000): void {
    this.toastSubject.next({ message, type: 'info', duration });
  }

  warning(message: string, duration = 3500): void {
    this.toastSubject.next({ message, type: 'warning', duration });
  }
}
